<template>
  <filter-parent v-if="showFilter" :title="title">
    <div class="radio-buttons-wrapper column">
      <div class="radio-button">
        <input
          :id="`gender-radio-any`"
          v-model="genders"
          type="radio"
          :value="null"
        />
        <label :for="`gender-radio-any`" class="marker" v-text="anyText" />
      </div>
      <div v-for="gender in genderOptions" :key="gender" class="radio-button">
        <input
          :id="`gender-radio-${gender}`"
          v-model="genders"
          type="radio"
          :value="gender"
        />
        <label :for="`gender-radio-${gender}`" class="marker" v-text="gender" />
      </div>
    </div>
  </filter-parent>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import FilterParent from '../common/FilterParent.vue';

export default defineComponent({
  name: 'GenderFilter',

  components: {
    FilterParent,
  },

  data() {
    return {
      title: window.theme_vars.counselorGridTexts.gender,
      anyText: window.theme_vars.counselorGridTexts.any,
    };
  },

  computed: {
    ...mapState('counselorGrid', ['genderOptions', 'isLoadingCompetenceAreas']),

    showFilter() {
      return this.isLoadingCompetenceAreas || this.genderOptions.length > 0;
    },

    genders: {
      get() {
        return this.$store.state.counselorGrid.filteredGender;
      },
      set(value) {
        this.$store.commit('counselorGrid/setFilteredGender', value);
      },
    },
  },
});
</script>
